import * as React from 'react';

export default () => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
        >
          <path d="M28 0H4C1.794 0 0 1.794 0 4v17.333c0 2.206 1.794 4 4 4h7.846a6.12 6.12 0 01-2.58 3.776l-.336.224H6.667a1.334 1.334 0 000 2.667h18.666a1.334 1.334 0 000-2.667H23.07l-.336-.224a6.12 6.12 0 01-2.58-3.776H28c2.206 0 4-1.794 4-4V4c0-2.206-1.794-4-4-4zm-8.853 29.333h-6.294a8.762 8.762 0 001.702-4h2.891a8.76 8.76 0 001.7 4zm10.186-8c0 .736-.598 1.334-1.333 1.334H4a1.335 1.335 0 01-1.333-1.334V4c0-.735.598-1.333 1.333-1.333h24c.735 0 1.333.598 1.333 1.333v17.333z"></path>
          <path d="M24 17.333h-1.333v-8a1.334 1.334 0 00-2.667 0v8h-2.667V12a1.334 1.334 0 00-2.666 0v5.333H12v-2.666a1.334 1.334 0 00-2.667 0v2.666H8A1.334 1.334 0 008 20h16a1.334 1.334 0 000-2.667z"></path>
        </svg>
    );
}